import Button from '@ui/components/Button/Button';

import './ScimEnterprisePaywall.scss';

const ScimEnterprisePaywall = () => (
	<div className="ScimEnterprisePaywall">
		<div className="ScimEnterprisePaywall-header">
			<div className="ScimEnterprisePaywall-title-row">
				<span className="ScimEnterprisePaywall-title">SCIM Provisioning</span>
				<span className="ScimEnterprisePaywall-badge">Enterprise Only</span>
			</div>
			<p className="ScimEnterprisePaywall-description">
				Connect your identity provider to automatically manage VeryBusy accounts when employees join,
				change roles, or leave. Copy your SCIM key and endpoint to your identity provider.{' '}
				{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
				<a className="ScimEnterprisePaywall-link" href="#">How to set up SCIM →</a>
			</p>
		</div>

		<div className="ScimEnterprisePaywall-actions">
			<Button size="xs" variant="filled">Contact Sales</Button>
			{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
			<a className="ScimEnterprisePaywall-learn-more" href="#">Learn More about Enterprise</a>
		</div>
	</div>
);

export default ScimEnterprisePaywall;
